export default __webpack_public_path__ + "static/media/enterfx.adec29b6.mp3";